<script>
  import app from "../stores/app";
  import theme from "../stores/theme";

  $: bg = $theme.mode == "dark" ? "bg-brand-black" : "bg-white";
  $: roleText =
    $theme.mode == "dark" ? "text-brand-yellow" : "text-brand-black";
  $: roleBorder =
    $theme.mode == "dark" ? "border-brand-yellow" : "border-brand-black";

  export let id;
  export let title = "Project Title";
  export let descEN =
    "Lorem ipsum dolor sit amet consctetur, adipisicing elit. Culpa architecto illum perferendis sapiente laboriosam sunt unde tempore, repellendus reiciendis fugiat voluptates quas aspernatur voluptatem dolore quidem molestias pariatur blanditiis quisquam. Commodi!";
  export let role = "Front-End Developer";
  // export let tech = "Html, Css, Javascript, Sass, React, Gatsby";
  export let year = "2020";
  export let url = "#";
  export let descFR;
  export let isPrivate = false;
  export let inProgress = false;
</script>

<div
  data-aos="fade-up"
  data-aos-offset="0"
  data-aos-delay={id * 50}
  data-aos-duration="500"
  class={`aos-item work-card ${bg} relative z-50 shadow-md mb-16 flex flex-col justify-between transition-transform duration-500`}
>
  <div>
    <img
      src="./images/card-tablets.svg"
      class="absolute left-0 opacity-50"
      style="top:50%; transform: translate(5px, -50%);"
      alt={`Card Tablet #${id}`}
    />
    <h1
      class="border-brand-red border-t-4 pt-4 pl-12 text-brand-red text-xl mb-6
      w-48 whitespace-no-wrap h-font"
    >
      {title}
    </h1>
    <div class="pl-12 pr-4">
      {#if $app.lang === "en"}
        <p class="ml-2 mb-6" style="min-height: 100px;">{descEN}</p>
      {:else}
        <p class="ml-2 mb-6" style="min-height: 100px;">{descFR}</p>
      {/if}
    </div>
  </div>

  <div>
    <div class="pl-12 pr-4">
      <div
        class={`ml-2 border-b ${roleBorder} mb-1 opacity-25`}
        style="border-style: dashed !important;"
      />
      <p class={`ml-2 ${roleText}`}>Role: {role}</p>
      <div
        class={`ml-2 border-b ${roleBorder} mt-1 mb-2 opacity-25`}
        style="border-style: dashed !important;"
      />
    </div>
    <div class="pl-12 ml-2 mt-8 flex justify-between">
      <p>{year}</p>
      {#if inProgress}
        <span
          class={`flex items-center text-red-400 border-red-400 border-b-4
         pb-4 pr-4 w-40 justify-end h-font`}
          style="cursor: not-allowed;"
        >
          {#if $app.lang === "en"}
            <span> In development</span>
          {:else}<span> Projet en cours </span>{/if}
          <span class="material-symbols-outlined text-xl ml-3"> pending </span>
        </span>
      {:else if isPrivate}
        <span
          class={`flex items-center ${roleText} ${roleBorder} border-b-4
           pb-4 pr-4 w-40 justify-end h-font`}
          style="cursor: not-allowed;"
        >
          {#if $app.lang === "en"}
            <span> Private project</span>
          {:else}<span> Projet privé </span>{/if}
          <span class="material-symbols-outlined text-xl ml-3">
            visibility_off
          </span>
        </span>
      {:else}
        <a
          href={url}
          target="_blank"
          class="flex text-brand-green items-center border-brand-green border-b-4
           pb-4 pr-4 w-40 justify-end h-font"
        >
          {#if $app.lang === "en"}
            <span> See the project </span>
          {:else}<span> Voir le projet </span>{/if}
          <span class="material-symbols-outlined text-xl ml-3">
            visibility
          </span>
        </a>
      {/if}
    </div>
  </div>
</div>

<style>
  .work-card {
    border-top-right-radius: 50px;
    border-bottom-left-radius: 50px;
  }
  .work-card:hover {
    transform: scale(1.03);
  }
</style>
